import React from 'react'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import ServiceOrderLoader from './_load/ServiceOrderLoader'

const TemplateSSOPgrTablePage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <PageHeader templateId={parseInt(templateId)} />
        <PageContent />
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateSSOPgrTablePage
